module.exports = "<div class=container style=margin-top:5%> <div class=\"jumbotron text-center\"> <h1>Logging out...</h1> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/authorization/logout/index.html
// module id = 380
// module chunks = 0